<template>
    <v-container>
        <v-overlay :value="isLoading" absolute>
            <v-progress-circular :size="70" :width="7" indeterminate></v-progress-circular>
        </v-overlay>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col>
                <h2 class="my-2">デバイス一覧</h2>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-row>
            <v-col cols="12" md="6" lg="4" v-for="obj of dbDevices" :key="obj.id">
                <v-card color="indigo lighten-4">
                    <v-toolbar color="indigo" dark>
                        <v-app-bar-nav-icon></v-app-bar-nav-icon>
                        <v-toolbar-title>{{ obj.name }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn small color="success" @click="openDlgClick(obj.id)"><h3>編集</h3></v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <h4>アイコン：{{ obj.icon_no == 0 ? "中" : obj.icon_no }}</h4>
                        <h4>軌跡カラー：<v-progress-linear value="100" height="7" :color="obj.poly_color"></v-progress-linear></h4>
                    </v-card-text>
                    <v-divider></v-divider>
                </v-card>
            </v-col>
        </v-row>
        <!-- ============================================================================================================================ -->
        <v-dialog v-model="showEditDlg" fullscreen transition="dialog-bottom-transition">
            <v-card color="grey lighten-4">
                <v-toolbar color="indigo" dark>
                    <v-toolbar-title>{{ dlgDevice.name }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showEditDlg = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-toolbar>
                <v-card-text class="mt-10">
                    <v-row>
                        <v-col>
                            <v-sheet class="pa-3" elevation="2">
                                <v-container>
                                    <v-row>
                                        <v-col cols="8">
                                            <v-text-field label="デバイス名" v-model="dlgDevice.name" outlined dense></v-text-field>
                                        </v-col>
                                        <v-col cols="4">
                                            <v-select label="アイコン" v-model="dlgDevice.icon_no" outlined dense :items="optMapIconNo" readonly background-color="grey lighten-3"></v-select>
                                        </v-col>
                                    </v-row>
                                    <v-menu v-model="dispColorDlg" :close-on-content-click="false" transition="scale-transition" min-width="auto" :nudge-bottom="40">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field label="軌跡カラー" v-model="dlgDevice.poly_color" readonly v-bind="attrs" v-on="on" dense outlined style="width: 120px"></v-text-field>
                                        </template>
                                        <v-color-picker v-model="dlgDevice.poly_color" mode="hexa" show-swatches swatches-max-height="400px" hide-canvas hide-inputs hide-sliders></v-color-picker>
                                    </v-menu>
                                    <v-divider class="mb-5"></v-divider>
                                    <div v-show="dlgDevice.is_repeater">
                                        <h3 class="mb-5">■ 中継機10ボタン設定</h3>
                                        <v-row>
                                            <v-col cols="12" sm="6">
                                                <v-text-field solo dense label="ボタン1" :background-color="dlgDevice.repeater_btns[0].color" v-model="dlgDevice.repeater_btns[0].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(0)"></v-text-field>
                                                <v-text-field solo dense label="ボタン2" :background-color="dlgDevice.repeater_btns[1].color" v-model="dlgDevice.repeater_btns[1].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(1)"></v-text-field>
                                                <v-text-field solo dense label="ボタン3" :background-color="dlgDevice.repeater_btns[2].color" v-model="dlgDevice.repeater_btns[2].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(2)"></v-text-field>
                                                <v-text-field solo dense label="ボタン4" :background-color="dlgDevice.repeater_btns[3].color" v-model="dlgDevice.repeater_btns[3].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(3)"></v-text-field>
                                                <v-text-field solo dense label="ボタン5" :background-color="dlgDevice.repeater_btns[4].color" v-model="dlgDevice.repeater_btns[4].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(4)"></v-text-field>
                                            </v-col>
                                            <v-col cols="12" sm="6">
                                                <v-text-field solo dense label="ボタン6" :background-color="dlgDevice.repeater_btns[5].color" v-model="dlgDevice.repeater_btns[5].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(5)"></v-text-field>
                                                <v-text-field solo dense label="ボタン7" :background-color="dlgDevice.repeater_btns[6].color" v-model="dlgDevice.repeater_btns[6].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(6)"></v-text-field>
                                                <v-text-field solo dense label="ボタン8" :background-color="dlgDevice.repeater_btns[7].color" v-model="dlgDevice.repeater_btns[7].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(7)"></v-text-field>
                                                <v-text-field solo dense label="ボタン9" :background-color="dlgDevice.repeater_btns[8].color" v-model="dlgDevice.repeater_btns[8].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(8)"></v-text-field>
                                                <v-text-field solo dense label="ボタン10" :background-color="dlgDevice.repeater_btns[9].color" v-model="dlgDevice.repeater_btns[9].text" append-outer-icon="mdi-palette-swatch-variant" @click:append-outer="colorSW(9)"></v-text-field>
                                            </v-col>
                                        </v-row>
                                    </div>
                                </v-container>
                            </v-sheet>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
                <v-card-text class="mt-5">
                    <v-row>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="showEditDlg = false" width="100" outlined>キャンセル</v-btn>
                        </v-col>
                        <v-col class="text-center pa-0">
                            <v-btn color="success" @click="axiosSubmit()" width="100">登録</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
                <!-- --------------------- -->
            </v-card>
        </v-dialog>
        <!-- ============================================================================================================================ -->
        <div class="ma-5 pa-5"></div>
        <div class="ma-5 pa-5"></div>
        <div class="ma-5 pa-5"></div>
        <div class="ma-5 pa-5"></div>
    </v-container>
</template>

<script>
export default {
    name: "Devices",
    data() {
        return {
            jwt: "",
            myInfo: { id: 0, name: "", user_id: 0, site_id: 0 },
            showEditDlg: false,
            isLoading: false,
            dbDevices: [],
            dlgInfo: {
                ipv4: "",
                local_ip: "",
                sd_ver: "",
            },
            dlgDevice: {
                id: 0,
                site_id: 0,
                mac: "ff:ff:ff:ff:ff:ff",
                name: "Newイケス",
                sort_no: 999,
                repeater_btns: [
                    { id: "a", text: "転倒/骨折", color: "blue" },
                    { id: "b", text: "転倒/滑落", color: "orange" },
                    { id: "c", text: "高所落下/打撲", color: "red" },
                    { id: "d", text: "高所落下/打撲", color: "orange" },
                    { id: "e", text: "刃物/チェンソー", color: "red" },
                    { id: "f", text: "倒木下敷き", color: "red" },
                    { id: "g", text: "重機/車輌転倒", color: "red" },
                    { id: "h", text: "蜂/蛇咬傷", color: "red" },
                    { id: "i", text: "体調不良/軽症", color: "orange" },
                    { id: "j", text: "体調不良/軽症", color: "green" },
                ],
            },
            optMapIconNo: [
                { value: 1, text: "1" },
                { value: 2, text: "2" },
                { value: 3, text: "3" },
                { value: 4, text: "4" },
                { value: 5, text: "5" },
                { value: 6, text: "6" },
                { value: 7, text: "7" },
                { value: 8, text: "8" },
                { value: 9, text: "9" },
                { value: 0, text: "中継機" },
            ],
            dispColorDlg: false,
        };
    },
    //========================================================
    created: async function () {
        this.jwt = this.$localStorage.get("jwt");
        if (!this.jwt) {
            this.$router.push({ name: "Login" });
            return;
        }
        this.myInfo = this.$jwt.decode(this.jwt);
        if (this.myInfo && this.myInfo.exp < this.$moment().unix()) {
            this.$router.push({ name: "Login" });
            return;
        }
        //-----------------------------------------------
        this.isLoading = true;
        //-----------------------------------------------
        //非同期でAxiosGet
        const promiseDevice = this.axiosGetDevices();
        //-----------------------
        //上記の終了を待つ
        await promiseDevice;
        //-----------------------
        await new Promise((r) => setTimeout(r, 500));
        //-----------------------
        this.isLoading = false;
        window.scrollTo(0, 0);
        //-----------------------------------------------
    },
    //========================================================
    computed: {},
    //========================================================
    methods: {
        //===================================================
        colorSW(btnNo) {
            const colors = ["green", "yellow", "red"];
            // const color = colors[btnNo];
            // self.console.log(color);

            const oldColor = this.dlgDevice.repeater_btns[btnNo].color;
            const idx = colors.indexOf(oldColor);
            //const newColor = "green lighten-3";
            const newColor = colors[(idx + 1) % 3];
            this.dlgDevice.repeater_btns[btnNo].color = newColor;
            this.dlgDevice = JSON.parse(JSON.stringify(this.dlgDevice));
        },
        //===================================================
        async axiosGetDevices() {
            await this.axios({
                method: "GET",
                url: "/web/api/devices",
                params: { "_order[name]": "asc" },
                headers: { Authorization: "Bearer " + this.jwt },
                timeout: 30000,
            }).then((response) => {
                this.dbDevices = response.data.json;
            });
        },
        //===================================================
        // 変更ダイアログ表示
        //===================================================
        openDlgClick(primaryKey) {
            //-----------------------------
            for (let obj of this.dbDevices) {
                if (obj.id == primaryKey) {
                    this.dlgDevice = JSON.parse(JSON.stringify(obj));
                    try {
                        const jsonStr = this.dlgDevice.repeater_btns;
                        const result = jsonStr.replace(/\\"/g, '"');
                        const jsonObj = JSON.parse(result);
                        this.dlgDevice.repeater_btns = jsonObj;
                        // self.console.log(this.dlgDevice);
                        self.console.log(jsonStr);
                    } catch {
                        this.dlgDevice.repeater_btns = [
                            { id: "a", text: "", color: "green" },
                            { id: "b", text: "", color: "green" },
                            { id: "c", text: "", color: "green" },
                            { id: "d", text: "", color: "green" },
                            { id: "e", text: "", color: "green" },
                            { id: "f", text: "", color: "green" },
                            { id: "g", text: "", color: "green" },
                            { id: "h", text: "", color: "green" },
                            { id: "i", text: "", color: "green" },
                            { id: "j", text: "", color: "green" },
                        ];
                    }
                }
            }
            this.showEditDlg = true;
            //-----------------------------
            // this.dlgDevice.repeater_btns = [
            //     { id: "a", text: "転倒/骨折", color: "red" },
            //     { id: "b", text: "転倒/滑落", color: "yellow" },
            //     { id: "c", text: "高所落下/打撲", color: "red" },
            //     { id: "d", text: "高所落下/打撲", color: "yellow" },
            //     { id: "e", text: "刃物/チェンソー", color: "red" },
            //     { id: "f", text: "倒木下敷き", color: "red" },
            //     { id: "g", text: "重機/車輌転倒", color: "red" },
            //     { id: "h", text: "蜂/蛇咬傷", color: "red" },
            //     { id: "i", text: "体調不良/軽症", color: "yellow" },
            //     { id: "j", text: "体調不良/軽症", color: "green" },
            // ];
            //-----------------------------
        },
        //===================================================
        // Dataをサブミット
        //===================================================
        async axiosSubmit() {
            let ErrCount = 0;
            if (!this.dlgDevice["name"]) ErrCount++;
            //if (!this.dlgDevice["icon_no"]) ErrCount++;
            if (!this.dlgDevice["poly_color"]) ErrCount++;
            if (ErrCount) {
                alert("未入力項目があります。");
                return false;
            }
            //-----------------------------------
            this.isLoading = true;
            this.showEditDlg = false;
            //-----------------------------------
            const axiosData = {
                name: this.dlgDevice["name"],
                icon_no: this.dlgDevice["icon_no"],
                poly_color: this.dlgDevice["poly_color"],
                repeater_btns: "",
            };
            //-----------------------------------
            if (this.dlgDevice.is_repeater == 1) {
                axiosData.repeater_btns = JSON.stringify(this.dlgDevice.repeater_btns);
            }
            //-----------------------------------
            const primaryKey = this.dlgDevice.id;
            await this.axios({
                method: "PUT",
                url: "/web/api/devices/" + primaryKey,
                headers: { Authorization: "Bearer " + this.jwt },
                data: axiosData,
                timeout: 30000,
            }).then(() => {
                this.axiosGetDevices();
            });
            //-----------------------------------
            await new Promise((r) => setTimeout(r, 100));
            this.isLoading = false;
        },
        //===================================================
    },
    //========================================================
};
</script>
